export default __webpack_public_path__ + "static/media/photo11.6aed1b70.jpg";